/**
 * Objectives domain field configuration
 * Static field definitions for calculated objective fields
 */
// Static field definitions for common Objectives fields
export const FIELDS = [
    // Basic info fields
    {
        key: "id",
        label: "ID",
        type: "string",
        align: "left",
    },
    {
        key: "region_de_ventas",
        label: "Región de ventas",
        type: "string",
        align: "left",
    },
    {
        key: "delegacion_zona_de_ventas",
        label: "Delegación + Sala + Ruta",
        type: "string",
        align: "left",
    },
    {
        key: "distribuidor",
        label: "Distribuidor",
        type: "string",
        align: "left",
    },
    {
        key: "sala",
        label: "Sala",
        type: "string",
        align: "left",
    },
    {
        key: "ano_natural",
        label: "Año",
        type: "integer",
        align: "center",
    },
    {
        key: "mes_natural",
        label: "Mes",
        type: "integer",
        align: "center",
    },
    // Volumen objective fields (normalized key names)
    {
        key: "volumen.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
    },
    {
        key: "volumen.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
    },
    {
        key: "volumen.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
    },
    {
        key: "volumen.cajas_faltantes",
        label: "Cajas faltantes",
        type: "float",
        align: "right",
    },
    {
        key: "volumen.porcentaje_conseguido",
        label: "% conseguido",
        type: "percent",
        align: "right",
    },
    // Volumen acumulado objective fields
    {
        key: "volumen_acumulado.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
    },
    {
        key: "volumen_acumulado.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
    },
    {
        key: "volumen_acumulado.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen_acumulado.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
    },
    {
        key: "volumen_acumulado.cajas_faltantes",
        label: "Cajas faltantes",
        type: "float",
        align: "right",
    },
    {
        key: "volumen_acumulado.porcentaje_conseguido",
        label: "% conseguido",
        type: "percent",
        align: "right",
    },
    // Clientes objective fields
    {
        key: "clientes.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
    },
    {
        key: "clientes.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
    },
    {
        key: "clientes.objetivo",
        label: "Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "clientes.clientes_faltantes",
        label: "Clientes faltantes",
        type: "float",
        align: "right",
    },
    {
        key: "clientes.porcentaje_conseguido",
        label: "% conseguido",
        type: "percent",
        align: "right",
    },
    // Ref. Promedio objective fields
    {
        key: "ref_promedio.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
    },
    {
        key: "ref_promedio.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
    },
    {
        key: "ref_promedio.porcentaje_conseguido",
        label: "% conseguido",
        type: "percent",
        align: "right",
    },
    // GDA objective fields
    {
        key: "gda.obj_ho_f1",
        label: "Grupo 1 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f1",
        label: "Grupo 1 Resultado",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f2",
        label: "Grupo 2 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f2",
        label: "Grupo 2 Resultado",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f3",
        label: "Grupo 3 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f3",
        label: "Grupo 3 Resultado",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f1",
        label: "Grupo 4 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f1",
        label: "Grupo 4 Resultado",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f2",
        label: "Grupo 5 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f2",
        label: "Grupo 5 Resultado",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f3",
        label: "Grupo 6 Objetivo",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f3",
        label: "Grupo 6 Resultado",
        type: "float",
        align: "right",
    },
];
